import { useLocation, useParams } from "react-router";
import { format, parseISO } from "date-fns";
import { PageWrapper } from "../../tabin/components/pageWrapper";

import "./reservationConfirmed.scss";

interface IReservationConfirmedState {
    reservationId: string;
    date: string;
    time: string;
    covers: number;
    customerName: string;
    restaurantName: string;
}

export const ReservationConfirmed = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const location = useLocation();
    const state = location.state as IReservationConfirmedState | null;

    if (!state) {
        return (
            <PageWrapper>
                <div className="reservation-confirmed-page">
                    <div className="reservation-confirmed-container">
                        <div className="reservation-confirmed-icon">✓</div>
                        <h1>Reservation Confirmed</h1>
                        <p>Your table has been reserved. See you soon!</p>
                    </div>
                </div>
            </PageWrapper>
        );
    }

    const { reservationId, date, time, covers, customerName, restaurantName } = state;

    const formattedDate = (() => {
        try {
            return format(parseISO(date), "EEEE, MMMM do yyyy");
        } catch {
            return date;
        }
    })();

    const formattedTime = (() => {
        try {
            const [h, m] = time.split(":");
            const d = new Date();
            d.setHours(parseInt(h), parseInt(m), 0);
            return format(d, "h:mm a");
        } catch {
            return time;
        }
    })();

    const shortId = reservationId.slice(-8).toUpperCase();

    return (
        <PageWrapper>
            <div className="reservation-confirmed-page">
                <div className="reservation-confirmed-container">
                    <div className="reservation-confirmed-icon">✓</div>

                    <h1 className="reservation-confirmed-title">You're booked in!</h1>
                    <p className="reservation-confirmed-subtitle">
                        We're looking forward to seeing you, {customerName.split(" ")[0]}.
                    </p>

                    <div className="reservation-confirmed-card">
                        <div className="reservation-confirmed-restaurant">{restaurantName}</div>

                        <div className="reservation-confirmed-details">
                            <div className="reservation-confirmed-detail">
                                <span className="reservation-confirmed-detail-icon">📅</span>
                                <span>{formattedDate}</span>
                            </div>
                            <div className="reservation-confirmed-detail">
                                <span className="reservation-confirmed-detail-icon">🕐</span>
                                <span>{formattedTime}</span>
                            </div>
                            <div className="reservation-confirmed-detail">
                                <span className="reservation-confirmed-detail-icon">👥</span>
                                <span>{covers === 1 ? "1 guest" : `${covers} guests`}</span>
                            </div>
                        </div>

                        <div className="reservation-confirmed-ref">
                            <span className="reservation-confirmed-ref-label">Reservation Reference</span>
                            <span className="reservation-confirmed-ref-value">{shortId}</span>
                        </div>
                    </div>

                    <p className="reservation-confirmed-note">
                        A confirmation has been recorded. Please contact the restaurant directly if you need to make changes.
                    </p>

                    <a className="reservation-confirmed-back" href={`/${restaurantId}/reservation`}>
                        Make Another Reservation
                    </a>
                </div>
            </div>
        </PageWrapper>
    );
};
